/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_CompleteInputs */

const en_team_project_import_complete = /** @type {(inputs: Team_Project_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing team project complete`)
};

const fr_team_project_import_complete = /** @type {(inputs: Team_Project_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du projet d’équipe terminée`)
};

const de_team_project_import_complete = /** @type {(inputs: Team_Project_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt des Importteams abgeschlossen`)
};

const it_team_project_import_complete = /** @type {(inputs: Team_Project_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione del progetto di gruppo completata`)
};

const ru_team_project_import_complete = /** @type {(inputs: Team_Project_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект команды по импорту завершен.`)
};

const es_team_project_import_complete = /** @type {(inputs: Team_Project_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación del proyecto del equipo completada`)
};

const zh_cn2_team_project_import_complete = /** @type {(inputs: Team_Project_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入团队项目完成`)
};

const ja_team_project_import_complete = /** @type {(inputs: Team_Project_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームプロジェクトのインポートが完了しました`)
};

const hi_team_project_import_complete = /** @type {(inputs: Team_Project_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम प्रोजेक्ट का आयात पूरा हो गया`)
};

const pt_pt2_team_project_import_complete = /** @type {(inputs: Team_Project_Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto de equipe de importação concluído`)
};

/**
* | output |
* | --- |
* | "Importing team project complete" |
*
* @param {Team_Project_Import_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_complete = /** @type {((inputs?: Team_Project_Import_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_complete(inputs)
	if (locale === "de") return de_team_project_import_complete(inputs)
	if (locale === "it") return it_team_project_import_complete(inputs)
	if (locale === "ru") return ru_team_project_import_complete(inputs)
	if (locale === "es") return es_team_project_import_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_complete(inputs)
	if (locale === "ja") return ja_team_project_import_complete(inputs)
	if (locale === "hi") return hi_team_project_import_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_complete(inputs)
	return en_team_project_import_complete(inputs)
});